module.exports = __webpack_public_path__ + "images/pflegegrad1.svg?34964fc9705d09d0cd6c84a77a9b01a3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/pflegegrad1.svg
// module id = UFbg
// module chunks = 0